const s = {
  name: "CashStack",
  dimensions: { width: 40, height: 38 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 38" style="enable-background:new 0 0 40 38;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M14,13c0-3.3,2.7-6,6-6s6,2.7,6,6c0,3.3-2.7,6-6,6S14,16.3,14,13z M20,9c-2.2,0-4,1.8-4,4s1.8,4,4,4
			c2.2,0,4-1.8,4-4S22.2,9,20,9z"/>
		<path class="st0" d="M9,4H4v5h2V6h3V4z"/>
		<path class="st0" d="M6,20v-3H4v5h5v-2H6z"/>
		<path class="st0" d="M34,17v3h-3v2h5v-5H34z"/>
		<path class="st0" d="M34,6h-3V4h5v5h-2V6z"/>
		<path class="st0" d="M0,0h40v26H0V0z M2,2v22h36V2H2z"/>
		<path class="st0" d="M0,28v2h40v-2H0z"/>
		<path class="st0" d="M0,34v-2h40v2H0z"/>
		<path class="st0" d="M0,36v2h40v-2H0z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as CashStack
};
